window.addEventListener('load', function () {
    let domains_filters = document.querySelectorAll('.domain-filter')
    if (!domains_filters.length) return

    let levels_filters = document.querySelectorAll('.level-filter')
    let trainings = document.querySelectorAll('.training-card')
    let all_btn = document.getElementById('all-filter')
    var domain_classes_to_show = []
    var level_classes_to_show = []

    domains_filters.forEach((domain) => {
        let checkbox = domain.querySelectorAll('.domain-switch')[0]

        if (domain.classList.contains('init-checked')) {
            domain_classes_to_show.push(checkbox.dataset.selector)
            checkbox.checked = true
            refresh_training()
        } else {
            checkbox.checked = false
        }

        checkbox.addEventListener('change', (event) => {
            if (event.target.checked) {
                domain_classes_to_show.push(event.target.dataset.selector)
            } else {
                domain_classes_to_show = domain_classes_to_show.filter((item) => item != event.target.dataset.selector)
            }
            refresh_training()
        })
    })

    levels_filters.forEach((level) => {
        let checkbox = level.querySelectorAll('.level-switch')[0]

        if (level.classList.contains('init-checked')) {
            level_classes_to_show.push(checkbox.dataset.selector)
            checkbox.checked = true
            refresh_training()
        } else {
            checkbox.checked = false
        }

        checkbox.addEventListener('change', (event) => {
            if (event.target.checked) {
                level_classes_to_show.push(event.target.dataset.selector)
            } else {
                level_classes_to_show = level_classes_to_show.filter((item) => item != event.target.dataset.selector)
            }
            refresh_training()
        })
    })

    all_btn.addEventListener('click', (event) => {
        domains_filters.forEach((domain) => {
            let checkbox = domain.querySelectorAll('.domain-switch')[0]
            checkbox.checked = false
        })
        levels_filters.forEach((level) => {
            let checkbox = level.querySelectorAll('.level-switch')[0]
            checkbox.checked = false
        })
        domain_classes_to_show = []
        level_classes_to_show = []
        pace = ''
        refresh_training()
    })

    function refresh_training() {
        trainings.forEach((training) => {
            let domain_to_show = false
            let level_to_show = false
            let pace_to_show = false

            // No specific domain selected, we show all
            if (domain_classes_to_show.length == 0) domain_to_show = true

            // Specific domain selected, we show only the selected ones
            if (domain_classes_to_show.length) {
                domain_classes_to_show.forEach((class_to_show) => {
                    if (training.classList.contains(class_to_show)) domain_to_show = true
                })
            }

            // No specific level selected, we show all
            if (level_classes_to_show.length == 0) level_to_show = true

            // Specific level selected, we show only the selected ones
            if (level_classes_to_show.length) {
                level_classes_to_show.forEach((class_to_show) => {
                    if (training.classList.contains(class_to_show)) level_to_show = true
                })
            }

            if (pace) {
                if (training.classList.contains(pace)) {
                    pace_to_show = true
                } else {
                    pace_to_show = false
                }
            } else {
                pace_to_show = true
            }

            if (domain_to_show && level_to_show && pace_to_show) {
                training.classList.remove('hidden')
            } else {
                training.classList.add('hidden')
            }
        })
    }

    refresh_training()
})
